import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { onSingleMailApiCollection, updateYouthAccount } from '../../util/api';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ShippingInfoPage/CLEAR_UPDATED_FORM';

export const UPDATE_PROFILE_REQUEST = 'app/ShippingInfoPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ShippingInfoPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ShippingInfoPage/UPDATE_PROFILE_ERROR';

export const UPDATE_YOUTH_PROFILE_REQUEST = 'app/ShippingInfoPage/UPDATE_YOUTH_PROFILE_REQUEST';
export const UPDATE_YOUTH_PROFILE_SUCCESS = 'app/ShippingInfoPage/UPDATE_YOUTH_PROFILE_SUCCESS';
export const UPDATE_YOUTH_PROFILE_ERROR = 'app/ShippingInfoPage/UPDATE_YOUTH_PROFILE_ERROR';

// ================ Reducer ================ //

const template_id = process.env.REACT_APP_INVITE_EMAIL_TO_YOUTH_TEMPLATE_ID;

const initialState = {
  updateInProgress: false,
  updateProfileError: null,

  updateYouthInProgress: null,
  updateYouthProfileError: null,
  updateYouthError: null
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

      case UPDATE_YOUTH_PROFILE_REQUEST:
        return {
          ...state,
          updateYouthInProgress: payload,
          updateYouthProfileError: null,
        };
      case UPDATE_YOUTH_PROFILE_SUCCESS:
        return {
          ...state,
          updateYouthInProgress: null,
        };
      case UPDATE_YOUTH_PROFILE_ERROR:
        return {
          ...state,
          image: null,
          updateYouthInProgress: null,
          updateYouthProfileError: payload.error,
          updateYouthError: payload.email
        };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const updateYouthProfileRequest = params => ({
  type: UPDATE_YOUTH_PROFILE_REQUEST,
  payload: params
});
export const updateYouthProfileSuccess = () => ({
  type: UPDATE_YOUTH_PROFILE_SUCCESS,
});
export const updateYouthProfileError = (error, email) => ({
  type: UPDATE_YOUTH_PROFILE_ERROR,
  payload: { error, email },
  error: true,
});

// ================ Thunk ================ //

export const inviteEmailToYouth = (actionPayload) => (dispatch, getState, sdk) => {
  const { youthsAccountDetails = [] } = actionPayload.publicData || {};
  const lastIndexData = youthsAccountDetails[youthsAccountDetails.length - 1] || {};

  if (lastIndexData?.accountActive) {
    const { uuid } = getState().user.currentUser.id || {};
    const data = {
      email: lastIndexData.youthEmail,  // Extract email correctly
      name: "Youth", // will update later
      signupUrl: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/signup/${lastIndexData.youthEmail}/${lastIndexData.youthDob}/${uuid}`
    };
    return onSingleMailApiCollection({ template_id, data });
  };
  return null; // Return null if no email is sent
};

export const updateYouthAccountStatus = (params, email) => (dispatch, getState, sdk) => {
  dispatch(updateYouthProfileRequest(email));
  return updateYouthAccount({ email }).then((res) => {
    if (res) {
      const queryParams = {
        expand: true,
        include: ['profileImage'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
      };
      return sdk.currentUser.updateProfile(params, queryParams).then((response) => {
        dispatch(updateYouthProfileSuccess(response));
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];
        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
      })
    };
  })
    .catch((error) => {
      dispatch(updateYouthProfileError(storableError(error), email));
    });
};

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(response => {
        dispatch(updateProfileSuccess(response));
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];

        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
        dispatch(inviteEmailToYouth(actionPayload));
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

